import React from 'react';
import Log from 'react-log';

const Headings = () => (
  <Log>
    <div>
      <h1>Lorem ipsum</h1>
      <h2>Lorem ipsum</h2>
      <h3>Lorem ipsum</h3>
      <h4>Lorem ipsum</h4>
      <h5>Lorem ipsum</h5>
      <h6>Lorem ipsum</h6>
    </div>
  </Log>
);

export default Headings;



// WEBPACK FOOTER //
// ./components/examples/Headings.js